import { Component, ElementRef, forwardRef, HostBinding, Input, ViewChild, ViewContainerRef } from '@angular/core';
import { Select, SelectModule } from 'primeng/select';
import { ControlValueAccessor, DefaultValueAccessor, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { LanguageService, SupportedLanguage } from 'src/app/services/language.service';
import React from 'react';

@Component({
  selector: 'app-language-select',
  imports: [SelectModule, ReactiveFormsModule],
  templateUrl: './language-select.component.html',
  styleUrl: './language-select.component.scss',
})
export class LanguageSelectComponent {

  @Input()
  control!: FormControl

  supportedLanguages = this.languageService.getSupportedLanguages()

  constructor(
    private languageService: LanguageService
  ) { }
}
